import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const cfg = { withCredentials: true };

export const STORY_EMOJIS = ['❤️', '🙏', '😮', '😢', '🔥', '😂'];

export const storiesApi = {
  create: async (payload) => (await axios.post(`${API}/api/community/stories`, payload, cfg)).data,
  tray: async () => (await axios.get(`${API}/api/community/stories/tray`, cfg)).data.tray,
  userStories: async (uid) => (await axios.get(`${API}/api/community/stories/user/${uid}?language=${localStorage.getItem('appLanguage') === 'es' ? 'es' : 'en'}`, cfg)).data.stories,
  answer: async (id, text) => (await axios.post(`${API}/api/community/stories/${id}/answer`, { text }, cfg)).data,
  view: async (id) => (await axios.post(`${API}/api/community/stories/${id}/view`, {}, cfg)).data,
  viewers: async (id) => (await axios.get(`${API}/api/community/stories/${id}/viewers`, cfg)).data,
  remove: async (id) => (await axios.delete(`${API}/api/community/stories/${id}`, cfg)).data,
  react: async (id, emoji) => (await axios.post(`${API}/api/community/stories/${id}/react`, { emoji }, cfg)).data,
  pin: async (id) => (await axios.post(`${API}/api/community/stories/${id}/pin`, {}, cfg)).data,
  highlights: async (uid) => (await axios.get(`${API}/api/community/stories/highlights/${uid}`, cfg)).data.highlights,
  removeHighlight: async (hid) => (await axios.delete(`${API}/api/community/stories/highlights/${hid}`, cfg)).data,
  save: async (id) => (await axios.post(`${API}/api/community/stories/${id}/save`, {}, cfg)).data,
  saved: async () => (await axios.get(`${API}/api/community/stories/saved/me`, cfg)).data.saved,
  removeSaved: async (sid) => (await axios.delete(`${API}/api/community/stories/saved/${sid}`, cfg)).data,
};
